import { Injectable } from '@angular/core';
import { DsconfigService, RestConnService } from '@services/services.module';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  private clientData: object;
  private offices: object;
  private wayToPay: object;
  private client: object;
  private list_clients: object;
  private divisions: object;

  constructor(
    private dsConfig: DsconfigService,
    private _res: RestConnService,
    public translate: TranslateService
  ) {
    this.list_clients = {
      'list_clients': dsConfig.getUrlBase() + '/ess/v1/client/all'
    };
    this.offices = {
      'offices': dsConfig.getUrlBase() + '/ess/v1/office/all'
    };
    this.clientData = {
      'clientData': dsConfig.getUrlBase() + '/ess/v1/client/client'
    };
    this.wayToPay = {
      'wayToPay': dsConfig.getUrlBase() + '/ess/v1/wayToPay/all'
    };
    this.divisions = {
      'divisions': dsConfig.getUrlBase() + '/ess/v1/division/active'
    };
  }

  addClient(data: any): Observable<any> {
    this.client = {
      'client': this.dsConfig.getUrlBase() + '/ess/v1/client'
    };

    if (data.clientId !== null) {
      return this._res
        .put('client', data,
          {
            collection: this.client
          });
    } else {
      return this._res
        .post('client', data,
          {
            collection: this.client
          });
    }
  }

  getClientData(idClient): Observable<any> {
    return this._res.get('clientData', { intCliId: idClient },
      {
        collection: this.clientData
      }
    );
  }

  getOffices(): Observable<any> {
    return this._res.get('offices', {},
      {
        collection: this.offices
      }
    );
  }

  getWayToPay(): Observable<any> {
    return this._res.get('wayToPay', {},
      {
        collection: this.wayToPay
      }
    );
  }

  getAllClients(): Observable<any> {
    return this._res.get('list_clients', {},
      {
        collection: this.list_clients
      }
    );
  }

  getDivisions(): Observable<any> {
    return this._res.get('divisions', {},
      {
        collection: this.divisions
      }
    );
  }
}
